module.exports = __webpack_public_path__ + "static/img/title_10.7335bf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/title_10.png
// module id = qiK4
// module chunks = 1